// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const Pagination = {
    cursor: (value) => {
        return Object.assign(Object.assign({}, value), { type: "cursor", _visit: function (visitor) {
                return FernIr.Pagination._visit(this, visitor);
            } });
    },
    offset: (value) => {
        return Object.assign(Object.assign({}, value), { type: "offset", _visit: function (visitor) {
                return FernIr.Pagination._visit(this, visitor);
            } });
    },
    custom: (value) => {
        return Object.assign(Object.assign({}, value), { type: "custom", _visit: function (visitor) {
                return FernIr.Pagination._visit(this, visitor);
            } });
    },
    uri: (value) => {
        return Object.assign(Object.assign({}, value), { type: "uri", _visit: function (visitor) {
                return FernIr.Pagination._visit(this, visitor);
            } });
    },
    path: (value) => {
        return Object.assign(Object.assign({}, value), { type: "path", _visit: function (visitor) {
                return FernIr.Pagination._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "cursor":
                return visitor.cursor(value);
            case "offset":
                return visitor.offset(value);
            case "custom":
                return visitor.custom(value);
            case "uri":
                return visitor.uri(value);
            case "path":
                return visitor.path(value);
            default:
                return visitor._other(value);
        }
    },
};
